import { render, staticRenderFns } from "./ClientEditAccountRecord.vue?vue&type=template&id=d5bf4886&scoped=true&"
import script from "./ClientEditAccountRecord.vue?vue&type=script&lang=js&"
export * from "./ClientEditAccountRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditAccountRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientEditAccountRecord.vue?vue&type=style&index=1&id=d5bf4886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bf4886",
  null
  
)

export default component.exports